export const APP_CONFIG = APPLICATION_CONFIG; // eslint-disable-line

export const APP_CONTAINER_CLASS = 'root';
export const APP_CONTAINER_SELECTOR = `.${APP_CONTAINER_CLASS}`;
export const CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export const ITEMS_PAGE_SIZE = 50;
export const CHANNELS_PAGE_SIZE = 50;
export const ORIGINAL_IMAGE_IDENTIFIER = '_xoriginal';

export const IS_DEVEL = process.env.NODE_ENV !== 'production';
